import type { Thread } from '@littlebird/sdk';

type ThreadLookup = {
  readonly getById: (threadId: string) => Pick<Thread, 'deletedAt'> | undefined;
};

// The chat is on this device and was not deleted
export const isLiveThread = (
  threads: ThreadLookup,
  threadId: string
): boolean => {
  const thread = threads.getById(threadId);
  return !!thread && !thread.deletedAt;
};
